export default "__VITE_ASSET__5e2e44e2__"